import { PartialSite } from "../models/site";
import axios from "./axiosConfig";

interface ChartDataOptions {
  [key: string]: any;
}

export default async function postSitePreviewHalfHourlyData(
  accessToken: string,
  dataType: string,
  options: ChartDataOptions,
  payload: PartialSite
): Promise<any> {
  const response = await axios.post(
    `/site/preview/chart_data/${dataType}?options=${JSON.stringify(options)}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return response.data;
}
